export default {
  apiKey: "AIzaSyCo2a7N4eWt4i0QadbEhhnxbOfwL1DogyE",
  authDomain: "boardgame-manager-2018.firebaseapp.com",
  databaseURL: "https://boardgame-manager-2018.firebaseio.com",
  projectId: "boardgame-manager-2018",
  storageBucket: "boardgame-manager-2018.appspot.com",
  messagingSenderId: "473964914862"
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js